import { render, staticRenderFns } from "./RecentVisitsCard.vue?vue&type=template&id=4c07f83c&scoped=true&"
import script from "./RecentVisitsCard.vue?vue&type=script&lang=js&"
export * from "./RecentVisitsCard.vue?vue&type=script&lang=js&"
import style0 from "./RecentVisitsCard.vue?vue&type=style&index=0&id=4c07f83c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07f83c",
  null
  
)

export default component.exports